// @ts-nocheck
import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import * as serviceWorker from "./serviceWorker"
import { Provider } from "react-redux"
import { configureStore } from "./redux/store"
import { DndProvider } from "react-dnd"
import HTML5Backend from "react-dnd-html5-backend"
import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client"
import { setContext } from "@apollo/client/link/context"

const evaGraphQlHttpLink = createHttpLink({
  uri:
    window.REACT_APP_GRAPHQL_URL ||
    process.env.REACT_APP_GRAPHQL_URL ||
    "http://localhost:5010/v1/graphql",
  fetch: (...args) => fetch(...args),
  credentials: "include",
})

const smartOfficeGraphQlHttpLink = createHttpLink({
  uri:
    window.REACT_APP_GRAPHQL_URL ||
    process.env.REACT_APP_GRAPHQL_URL ||
    "http://localhost:5010/v1/graphql",
  fetch: (...args) => fetch(...args),
  credentials: "include",
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("access_token")
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  }
})

const smartOfficeAuthLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("access_token")
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  }
})

export const evaGraphQlClient = new ApolloClient({
  link: authLink.concat(evaGraphQlHttpLink),
  cache: new InMemoryCache(),
})

export const smartOfficeGraphQlClient = new ApolloClient({
  link: smartOfficeAuthLink.concat(smartOfficeGraphQlHttpLink),
  cache: new InMemoryCache(),
})

const App = React.lazy(() => import(/* webpackChunkName: "App" */ "./App"))

ReactDOM.render(
  <Provider store={configureStore()}>
    <Suspense fallback={<div className="loading" />}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </Suspense>
  </Provider>,
  document.getElementById("root")
)
/*
 * If you want your app to work offline and load faster, you can change
 * unregister() to register() below. Note this comes with some pitfalls.
 * Learn more about service workers: https://bit.ly/CRA-PWA
 */
serviceWorker.unregister()
